/**
 * 电话图标
 */
const TelephoneIcon = ({ width = 16, height = 16, color = '#444446', fill = 'none' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_49690_30020)">
        <path
          d="M4.31944 1.66406L1.66309 3.67929C4.32329 10.3371 6.32279 12.3757 12.3228 14.339L14.3377 11.6824L12.323 9.66761L10.9911 9.67313L10.2036 10.5513C7.65919 9.79595 5.86764 6.96906 5.29613 5.64383L6.32473 5.00675L6.32473 3.66936L4.31944 1.66406Z"
          stroke={color}
          strokeWidth="1.33333"
        />
      </g>
      <defs>
        <clipPath id="clip0_49690_30020">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default TelephoneIcon
